export default "__VITE_ASSET__CI1r0P_Z__"